export default "dist/images/block-blog-posts-image-card.4920b4e.png";